export const TICKET_CHAT   = 'TICKET_CHAT';
export const NOTIFICATIONS   = 'NOTIFICATIONS';
export const MEETING_CHAT   = 'MEETING_CHAT';

export const WEB_SOCKET_CHANNELS   = [TICKET_CHAT, NOTIFICATIONS, MEETING_CHAT];